
/**
 * Triggers a download of a file from a given URL.
 */
function triggerDownload(url, filename) {
  const link = document.createElement('a');

  fetch(url)
    .then((response) => {
      return response.blob()
    })
    .then((blob) => {
      const url = URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link
        .download = filename

      document
        .body
        .appendChild(link)
      link
        .click()
      document
        .body
        .removeChild(link)

      URL.revokeObjectURL(url)
    })
    .catch(console.error)


  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);


}

/**
 * Polyfills download links by adding a click event listener to each link
 * with a 'download' attribute, triggering the download using `triggerDownload`.
 */
function polyfillDownloadLinks() {
  const downloadLinks = document.querySelectorAll('a[download]');
  downloadLinks.forEach(link => {
    const url = link.href;
    const filename = link.getAttribute('download') || url.split('/').pop();
    link.addEventListener('click', function (event) {
      event.preventDefault();
      triggerDownload(url, filename);
    });
  });
}

export function init() {
  polyfillDownloadLinks();
}
